module.exports = __webpack_public_path__ + "static/logo-ea4815886dceba33b79da987b23b1102.svg";